"use client"

import { createContext, useContext, useState, ReactNode } from "react"

interface FloatingPromptBarContextValue {
  isVisible: boolean
  show: () => void
  hide: () => void
  toggle: () => void
}

const FloatingPromptBarContext = createContext<FloatingPromptBarContextValue | null>(null)

export function FloatingPromptBarProvider({ children }: { children: ReactNode }) {
  const [isVisible, setIsVisible] = useState(true)

  return (
    <FloatingPromptBarContext.Provider
      value={{
        isVisible,
        show: () => setIsVisible(true),
        hide: () => setIsVisible(false),
        toggle: () => setIsVisible((v) => !v),
      }}
    >
      {children}
    </FloatingPromptBarContext.Provider>
  )
}

export function useFloatingPromptBar() {
  const ctx = useContext(FloatingPromptBarContext)
  if (!ctx) {
    throw new Error("useFloatingPromptBar must be used within FloatingPromptBarProvider")
  }
  return ctx
}







